import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { DocumentsServe } from 'src/app/utils/constants';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent {
  @Input() userName: string | null;
  @Input() userImage: string | null;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.userName = null;
    this.userImage = null;
  }

  buildImageUser(): string {
    return this.userImage
      ? DocumentsServe.USERPHOTOS + '/' + this.userImage
      : 'assets/img/imagge.jpg';
  }

  logout(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('session');
      localStorage.removeItem('token');
      localStorage.removeItem('expires_at');
      window.location.reload();
    }
  }
}
